import NewspaperSimpleView from './NewspaperSimpleView'

export default NewspaperSimpleView
